import { drawRoundedPolygon, fitToSize, inflatePolygon, sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
/**
 * Represents a Merge shape, a flowchart element used to indicate the merging
 * of multiple processes or data streams. Extends Rectangle with a triangular path.
 */
export class Merge extends Rectangle {
    /**
     * @hidden
     * Draws the merge shape path as an inverted triangle.
     */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const strokeWidth = this.options.stroke.width || 0;
        const points = [
            { x: 0, y: 0 },
            { x: width, y: 0 },
            { x: width / 2, y: height }
        ];
        const inflated = inflatePolygon(points, this.options.cornerRadius);
        drawRoundedPolygon(drawingElement, inflated, this.options.cornerRadius);
        fitToSize(drawingElement, width, height, strokeWidth);
    }
}
